<template>
  <div class="w-100">
    <v-tooltip bottom max-width="300">
      <template #activator="{ on, attrs }">
        <div
          :style="rowStyle"
          class="ar-general-admission"
          @click="showModal = true"
          v-on="on"
        >
          <div class="label">Зона за правостоящи</div>
        </div>
      </template>

      За да закупите билет в зоната за правостоящи, моля кликнете върху нея и
      след това изберете броя билети, които желаете
    </v-tooltip>

    <v-dialog v-model="showModal" width="350">
      <v-card>
        <v-card-title>{{ row[0].indexFriendly }}</v-card-title>
        <v-card-subtitle
          ><small>Това е зона за правостоящи</small></v-card-subtitle
        >
        <v-card-text>
          <div class="py-2">
            Билет за {{ row[0].indexFriendly }}
            <b>
              ({{ row[0].price }}{{ event.currencySign }} - цена за 1 брой)</b
            >
            <br />
          </div>
          <div class="tickets-selector">
            <v-btn primary icon @click="decreaseSelectedTickets">
              <v-icon>mdi-minus</v-icon>
            </v-btn>
            <v-text-field
              class="seats-counter"
              type="number"
              v-model="selectedTickets"
              min="0"
              :max="maxSelected"
              regu
            ></v-text-field>
            <v-btn primary icon @click="increaseSelectedTickets">
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn @click="setTickets" color="primary">Добави</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { useEvent } from '../../../stores/event'

export default {
  name: 'GaSection',
  props: {
    row: {
      type: Array,
      required: true,
    },
    selectedGaSeats: {
      type: [Array, Object],
      required: true,
    },
  },
  setup() {
    const event = useEvent()

    return {
      event,
    }
  },
  data() {
    return {
      selectedTickets: 0,
      showModal: false,
    }
  },
  computed: {
    maxSelected() {
      const limit =
        parseInt(this.row[0].totalTickets) - parseInt(this.row[0].ticketsSold)
      return limit > 10 ? 10 : limit
    },
    rowStyle() {
      return {
        height: this.row[0].height ? `${this.row[0].height}px` : `20px`,
        color: this.row[0].textColor ? this.row[0].textColor : '#333',
        backgroundColor: this.row[0].bgColor ? this.row[0].bgColor : '#ccc',
      }
    },
  },
  methods: {
    increaseSelectedTickets() {
      this.selectedTickets++

      let limit =
        parseInt(this.row[0].totalTickets) - parseInt(this.row[0].ticketsSold)
      limit = limit > 10 ? 10 : limit

      this.selectedTickets =
        this.selectedTickets > limit ? limit : this.selectedTickets
    },
    decreaseSelectedTickets() {
      this.selectedTickets--
      this.selectedTickets = this.selectedTickets < 0 ? 0 : this.selectedTickets
    },
    setTickets() {
      this.$emit('set-selection-to', this.selectedTickets)
      this.showModal = false
    },
    // getGaById(rowID) {
    //   return this.schema.filter((item) => {
    //     return item.length === 1 && item[0].type === "GA" && item[0].id === rowID
    //   })[0]
    // },
    // getGaSelectItems(row) {
    //   let limit = (parseInt(row.totalTickets) - parseInt(row.ticketsSold))
    //   limit = limit > 10 ? 10 : limit
    //
    //   let values = []
    //   for (let i = 1; i <= limit; i++) {
    //     if (i === 1) {
    //       values.push({text: '1 билет', value: i})
    //     } else {
    //       values.push({text: i +' билета', value: i})
    //     }
    //
    //   }
    //   return values
    // }
  },
}
</script>

<style lang="scss" scoped>
.ar-general-admission {
  width: 100%;
  text-align: center;
  border-radius: 3px;
  padding: 10px 20px 10px 20px;
  background: #e0f2f1;
  border: 1px solid #009688;
  font-size: 16px;
  cursor: pointer;
  color: #333;
  margin: 10px auto 10px 0px;
  display: flex;
  justify-content: center;
  align-items: center;

  &:hover {
    box-shadow: 0 0 5px 0 #ccc;
  }

  .label {
  }
}
.tickets-selector {
  display: flex;
  justify-content: center;
  justify-items: center;
  align-items: center;
}
.seats-counter {
  max-width: 70px;
  margin: 0 20px;
}
</style>
